import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { HeightLimitedExpander } from 'cat-ecommerce-alloy';
import { SPECIFICIFICATIONS_ID } from '../constants';
import { useSelector } from 'react-redux';
import { isEmpty, replaceTokensInString } from '../../../../utils';
import { UOM } from '../../../../constants/commonConstants';
import UnitOfMeasureToggle from '../../../common/UnitOfMeasureToggle/UnitOfMeasureToggle';
import styles from './styles.module.scss';

const ProductSpecifications = ({
  productId,
  setUnitOfMeasure,
  unitOfMeasure
}) => {
  const [t] = useTranslation();
  const attributes = useSelector(
    s => s.products?.byId?.[productId]?.attributes || []
  );
  const showSpecificationsToggle = useSelector(
    s => s.products?.byId?.[productId]?.showSpecificationsToggle
  );
  const partNumber = useSelector(
    s => s.products?.byId?.[productId]?.partNumber || ''
  );
  const title = replaceTokensInString(t('PDP_SPECIFICATIONS'), partNumber);

  const getFilteredSpecifications = () => {
    if (!showSpecificationsToggle) {
      return attributes;
    } else {
      const unit = unitOfMeasure === UOM.us ? UOM.metric : UOM.us;
      return attributes.filter(a => a.uom !== unit);
    }
  };
  // This radio group is being rendered twice in this component; one for desktop and one for mobile.
  // We cannot have two radios with the same name in the DOM due to only one will have the checked status.
  // So, We are passing a different name for each viewport.

  return (
    <section className="py-3" id={SPECIFICIFICATIONS_ID}>
      <div className="d-flex justify-content-between align-items-end mb-3 mb-lg-2 display-3 h3">
        <h2 className="h3 mb-0">{title}</h2>
        <UnitOfMeasureToggle
          className="d-none d-lg-flex"
          name="desktop"
          setUnitOfMeasure={setUnitOfMeasure}
          showToggle={showSpecificationsToggle}
          unitOfMeasure={unitOfMeasure}
          showLabel
          labelClass={styles['uom-label']}
        />
      </div>
      {!isEmpty(attributes) ? (
        <HeightLimitedExpander
          buttonSize="large"
          id="specificationsExpander"
          lessButtonText={t('VIEW_LESS')}
          moreButtonText={t('VIEW_MORE_PRODUCTS')}
        >
          <UnitOfMeasureToggle
            className="d-block d-lg-none"
            name="mobile"
            setUnitOfMeasure={setUnitOfMeasure}
            showToggle={showSpecificationsToggle}
            unitOfMeasure={unitOfMeasure}
            showLabel
            labelClass="my-0"
          />
          <ul className={`list-group ${styles['product-specifications-list']}`}>
            {getFilteredSpecifications().map(a => (
              <li key={a.name}>
                <p className="exclude-global mb-0 u-color--DarkGray text-sm">
                  <b>{`${a.name}: `}</b>
                  {a.value}
                </p>
              </li>
            ))}
          </ul>
        </HeightLimitedExpander>
      ) : (
        <p className="exclude-global">
          {t('PART_SPECIFICATION_INFORMATION_NOT_AVAILABLE')}
        </p>
      )}
    </section>
  );
};

ProductSpecifications.propTypes = {
  productId: PropTypes.string,
  setUnitOfMeasure: PropTypes.func.isRequired,
  unitOfMeasure: PropTypes.string.isRequired
};
export default ProductSpecifications;
